import React from 'react';
import { MenuItem } from '../../../components/Menu';
import trashIcon from '../../../icons/non-prefilled/16x16/trash.svg';
import { useToolbarOverflowMenuClose } from './Toolbar';

interface DeleteMenuItemProps {
  children: React.ReactNode;
  onClick: () => void;
}

const DeleteMenuItem = ({ onClick, children }: DeleteMenuItemProps) => {
  const closeOverflowMenu = useToolbarOverflowMenuClose();

  return (
    <MenuItem
      icon={trashIcon}
      onClick={() => {
        onClick();
        closeOverflowMenu();
      }}
      danger
    >
      {children}
    </MenuItem>
  );
};

export default DeleteMenuItem;
